var React = require('react');

function ChevronLargeDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Chevron/Large—down"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M7.78893022,9.01156752 C7.43436571,8.66281083 6.86556225,8.66281083 6.51099775,9.01156752 C6.16246312,9.36559479 6.16697485,9.91874055 6.51099775,10.2571283 L11.9751898,15.6318162 C12.2671223,15.9189668 12.7354495,15.9189668 13.027382,15.6318162 L18.4915741,10.2571283 C18.8401087,9.90310103 18.835597,9.34995528 18.4915741,9.01156752 C18.1370096,8.66281083 17.5682061,8.66281083 17.2136416,9.01156752 L12.5012859,13.6467342 L7.78893022,9.01156752 Z","id":"path-1","key":2})]);
}

ChevronLargeDown.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","fill":"currentColor","version":"1.1"};

module.exports = ChevronLargeDown;

ChevronLargeDown.default = ChevronLargeDown;
